import * as actionTypes from '../constants/actionTypes';

export default(state = {}, action) => {
    switch (action.type) {
        case actionTypes.GET_SYSTEM_SETTINGS:
            return {
                ...state,
                system_settings: action.payload
            };
        default:
            return state;
    }
};